var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page container pt-2 mt-3"},[(_vm.status)?_c('b-skeleton-img'):_c('div',{attrs:{"id":"contentPage"}},[_c('PagesPath',{attrs:{"path-title1":_vm.content.title,"pathTo1":_vm.$route.path}}),_c('div',{staticClass:"white-bg",domProps:{"innerHTML":_vm._s(_vm.content.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }